import { AuthConfig } from 'angular-oauth2-oidc';
export const FsxB2CDocumentDiscoveryURL = 'https://fileandserveagencydemo.b2clogin.com/fileandserveagencydemo.onmicrosoft.com/B2C_1A_DEMO_EMAIL_SIGNIN/v2.0/.well-known/openid-configuration';
const FsxB2CClientId = 'f8695823-68e1-46d4-86f2-2eeadb7a13f8';
const FsxB2CScopes = 'openid profile email offline_access https://fileandserveagencydemo.onmicrosoft.com/f8695823-68e1-46d4-86f2-2eeadb7a13f8/access_as_user';
const FsxB2CIssuer = 'https://fileandserveagencydemo.b2clogin.com/bbdba3d7-d268-4ae2-8dd3-dda3ee71fbbd/v2.0/'
const FsxB2CLoginUrl = 'https://fileandserveagencydemo.b2clogin.com/fileandserveagencydemo.onmicrosoft.com/B2C_1A_DEMO_EMAIL_SIGNIN/oauth2/v2.0/authorize';
const FsxB2CLogoutUrl = 'https://fileandserveagencydemo.b2clogin.com/fileandserveagencydemo.onmicrosoft.com/B2C_1A_DEMO_EMAIL_SIGNIN/oauth2/v2.0/logout'

export const authConfig: AuthConfig = {
  // ToDo: Need to store these magic strings in environment variables.
  issuer: FsxB2CIssuer,
  loginUrl: FsxB2CLoginUrl,
  logoutUrl: FsxB2CLogoutUrl,
  // ToDo: I believe we need to register all possible returnUri's in the Azure AD B2C App Registration
  redirectUri: window.location.origin + '/index.html',
  clientId: FsxB2CClientId,
  responseType: 'code',
  strictDiscoveryDocumentValidation: false,
  scope: FsxB2CScopes,
  showDebugInformation: false,
  skipIssuerCheck: false,
  // timeoutFactor: .01
}
